"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InputVariants = exports.InputVariantPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var InputVariants = exports.InputVariants = Object.freeze({
  DEFAULT: 'default',
  INVERSE: 'inverse'
});
var InputVariantPropType = exports.InputVariantPropType = _propTypes["default"].oneOf(Object.values(InputVariants));
var _default = exports["default"] = InputVariantPropType;